export namespace INTEGRATION_KEY {
    export const D_TOOLS = "d-tools"
    export const QUICK_BOOKS = "quick-books"
    export const OUTLOOK = "outlook"
    export const CALENDY = "calendly"
    export const LIGHTSPEED = "lightspeed"
    export const LIGHTSPEED_RETAIL = "ls-retail"
    export const LIGHTSPEED_ECOM = "ls-ecom"
    export const LIGHTSPEED_ECOM_OMNI = "ls-ecom-omni"
    export const LIGHTSPEED_ECOM_OMNI_NA = "ls-ecom-omni-na"
    export const VEND = "vend"
    export const LIGHTSPEED_GOLF = "ls-golf"
    export const HUBSPOT = "hubspot"
    export const STRIPE = "stripe"
    export const PAYSAFE = "paysafe"
    export const CSV = "csv"
    export const CUSTOM_SMTP = "custom-smtp"
    export const KANGAROO = "kangaroo"
    export const ZAPIER_MU2 = "zapier-mu2"
    export const ZAPIER = "zapier"
    export const ZENDESK_SUPPORT_MU2 = "zendesk-support-mu2"
    export const ALICE_POS = "alice-pos"
    export const ZENDESK_SELL = "zendesk-sell"
    export const NYLAS = "nylas"
    export const NYLASV3="nylasv3"
    export const SQUARE = "square"
    export const SQUARE_PAYMENTS = "square-payments"
    export const SHOPIFY = "shopify"
    export const SHOPIFY_EXPERT_APP = "shopify-expert-app"
    export const PIPEDRIVE = "pipedrive"
    export const WIX = "wix"
    export const RAINFOREST = "rainforest"
    export const MAILCHIMP = "mailchimp"
    export const ZENDESK_SUPPORT="zendesk-support"
    export const FRESHBOOKS="freshbooks"
}
export type INTEGRATION_KEY = typeof INTEGRATION_KEY[keyof typeof INTEGRATION_KEY];

export const INTEGRATION_LABEL = {
    [INTEGRATION_KEY.LIGHTSPEED]: "Lightspeed",
    [INTEGRATION_KEY.LIGHTSPEED_RETAIL]: "Lightspeed R-Series",
    [INTEGRATION_KEY.LIGHTSPEED_ECOM]: "Lightspeed eCom",
    [INTEGRATION_KEY.VEND]: "Lightspeed X-Series",
    [INTEGRATION_KEY.LIGHTSPEED_GOLF]: "Lightspeed Golf",
    [INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI] : "Lightspeed eCom",
    [INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI_NA] : "Lightspeed eCom",
    [INTEGRATION_KEY.SHOPIFY]: "Shopify",
    [INTEGRATION_KEY.SHOPIFY_EXPERT_APP] : "shopify-expert-app",
    [INTEGRATION_KEY.QUICK_BOOKS]: "QuickBooks",
    [INTEGRATION_KEY.SQUARE]: "Square",
    [INTEGRATION_KEY.SQUARE_PAYMENTS]: "Square",
    [INTEGRATION_KEY.PAYSAFE]: "Paysafe",
    [INTEGRATION_KEY.STRIPE]: "Stripe",
    [INTEGRATION_KEY.D_TOOLS] : "D-Tools",
    [INTEGRATION_KEY.OUTLOOK] : "Outlook",
    [INTEGRATION_KEY.CALENDY] : "Calendly",
    [INTEGRATION_KEY.HUBSPOT] : "HubSpot",
    [INTEGRATION_KEY.CSV] : "CSV",
    [INTEGRATION_KEY.CUSTOM_SMTP] : "SMTP",
    [INTEGRATION_KEY.KANGAROO] : "Kangaroo",
    [INTEGRATION_KEY.ZAPIER_MU2] : "Zapier",
    [INTEGRATION_KEY.ZAPIER] : "Zapier",
    [INTEGRATION_KEY.ZENDESK_SUPPORT_MU2] : "Zendesk",
    [INTEGRATION_KEY.ALICE_POS] : "Alice POS",
    [INTEGRATION_KEY.ZENDESK_SELL] : "Zendesk Sell",
    [INTEGRATION_KEY.NYLAS] : "Nylas",
    [INTEGRATION_KEY.NYLASV3] : "Nylas V3",
    [INTEGRATION_KEY.PIPEDRIVE]: "Pipedrive",
    [INTEGRATION_KEY.WIX] : "Wix",
    [INTEGRATION_KEY.RAINFOREST] : "QuoteMachine Payments",
    [INTEGRATION_KEY.MAILCHIMP] : "Mailchimp",
    [INTEGRATION_KEY.ZENDESK_SUPPORT] : "Zendesk Support",
    [INTEGRATION_KEY.FRESHBOOKS] : "FreshBooks",
}

export const INTEGRATION_LABEL_OLD = {
    [INTEGRATION_KEY.LIGHTSPEED_RETAIL]: "Retail",
    [INTEGRATION_KEY.VEND]: "Vend",
}

export const INTEGRATIONS_TERMINAL_PAYMENT_SUPPORT = [
    INTEGRATION_KEY.RAINFOREST
]

export const INTEGRATIONS_PAYMENT_REFUND_SUPPORT = [
    INTEGRATION_KEY.RAINFOREST
]

export const PAYMENT_INTEGRATION_KEYS = [
    INTEGRATION_KEY.RAINFOREST,
    INTEGRATION_KEY.SQUARE_PAYMENTS,
    INTEGRATION_KEY.PAYSAFE,
    INTEGRATION_KEY.STRIPE,
    INTEGRATION_KEY.SQUARE,
]


// WEBPACK FOOTER //
// ./src/state/integration/Constants.ts